// iter 178u: single-tap EN ⇄ ZH toggle. Lives in the Topbar. i18next
// persists the choice to localStorage("app_lang") so it survives reloads.
import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";

export default function LanguageToggle() {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "en").startsWith("zh") ? "zh" : "en";
  const next = current === "zh" ? "en" : "zh";
  return (
    <button
      type="button"
      data-testid="language-toggle"
      onClick={() => i18n.changeLanguage(next)}
      title={current === "zh" ? "切换到 English" : "Switch to 中文"}
      className="h-6 px-2 rounded-md border border-gray-200 text-[11px] font-medium text-gray-600 hover:text-brand-700 hover:border-brand-300 flex items-center gap-1 transition-colors"
    >
      <Languages size={12} strokeWidth={1.75} />
      <span className="font-mono">{current === "zh" ? "中" : "EN"}</span>
    </button>
  );
}
